import { render, staticRenderFns } from "./reportDetail_reportItem.vue?vue&type=template&id=0d4a7170&scoped=true"
import script from "./reportDetail_reportItem.vue?vue&type=script&lang=js"
export * from "./reportDetail_reportItem.vue?vue&type=script&lang=js"
import style0 from "./reportDetail_reportItem.vue?vue&type=style&index=0&id=0d4a7170&scoped=true&lang=scss"
import style1 from "./reportDetail_reportItem.vue?vue&type=style&index=1&id=0d4a7170&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4a7170",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d4a7170')) {
      api.createRecord('0d4a7170', component.options)
    } else {
      api.reload('0d4a7170', component.options)
    }
    module.hot.accept("./reportDetail_reportItem.vue?vue&type=template&id=0d4a7170&scoped=true", function () {
      api.rerender('0d4a7170', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/storeFeedback/reportDetail_reportItem.vue"
export default component.exports